import { TipoEmpleadoEnumChoice, TipoPlanEnumChoice } from "@/shared";
import { useEmpleadoStore } from "@/store/erp/empleado";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAsignarZonaFlota } from "./flotas";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";

export type ServicionsModuleProps = {};

const DEPARTMENT_ID = "DEPAcb431155-71eb-4af7-b7a0-eadebb61742b";

const MantenimientoOperacionModule: React.FC = () => {
  const getZone = useAsignarZonaFlota((s) => s.getZone);
  const getEmpleadoColor = useEmpleadoStore((s) => s.getEmpleadoColor);
  const getPlans = usePlanStore((s) => s.getPlans);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          getEmpleadoColor({
            departamento: DEPARTMENT_ID,
            tipo_empleado: TipoEmpleadoEnumChoice.TECNICO,
            page_size: 600,
            estado: true
          }),
          getZone({ page_size: 100 }),
          getPlans({
            page_size: 100,
            estado: true,
            tipo_plan: TipoPlanEnumChoice.PYMES
          })
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [getEmpleadoColor, getZone]);

  return <Outlet />;
};

export default MantenimientoOperacionModule;
